import React from 'react'
import withSizes from 'react-sizes'


const mapSizesToProps = ({ width }) => ({
  isTiny: width < 768,
  isSmall: width >= 768 && width < 992,
  isMedium: width >= 992 && width < 1200,
  isLarge: width >= 1200,
});

export default withSizes(mapSizesToProps)